import React from 'react'
import { ucFirst } from '../../../helpers/string_helper'
import { ActivityModule, Modules } from '../../../constants/Module'
import { Action, Role } from '../../../constants/Common'
import CreatorDetails from '../../../pages/ChangeRequest/activities/creatorDetails'
import { withTranslation } from 'react-i18next'
function ProjectUser({item, t}) {
  return (
    <div>
    <strong>{item?.payload?.user?.name} </strong>
     {item.event === Action.CREATE ? t('was added as') : t('was updated as')} {item?.payload?.role?.name === Role.PROJECT_MANAGER ? t('Founder') : item?.payload?.role?.name } {t('to')} <strong>{t('startup')} {ucFirst(item.project.name)} ({item?.project?.uniqueProjectId})</strong> {t('by')} 
    <CreatorDetails creator={item?.creator} date={item?.createdAt} />
</div>
  )
}
export default withTranslation()(ProjectUser)
